import no_found_image from 'assets/img/stores/no_logo_url.png';
import { SyntheticEvent } from 'react';

export const fallbackURL = (e: SyntheticEvent<HTMLImageElement>) => {
  e.currentTarget.src = no_found_image;
};
